import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function LegendaryStreakIllustration({
  achievementId,
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3869" data-mp="s03tdkjgs4fh">
      <div className="relative w-full h-full bg-gradient-to-b from-purple-800 to-fuchsia-900 overflow-hidden" data-id="element-3870" data-mp="11wgmag76qe96">
        {/* Background: Royal Hall / Throne Room */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3871" data-mp="1fp67iiew3f58">
          {/* Columns */}
          <rect x="20" y="0" width="20" height="200" fill="#4C1D95" data-id="element-3872" data-mp="1pj54l303w8qb" />
          <rect x="25" y="0" width="10" height="200" fill="#5B21B6" data-id="element-3873" data-mp="1knzjg6ej2y3a" />
          <rect x="160" y="0" width="20" height="200" fill="#4C1D95" data-id="element-3874" data-mp="2nwtjd8a3yssg" />
          <rect x="165" y="0" width="10" height="200" fill="#5B21B6" data-id="element-3875" data-mp="2suv5k22tz885" />

          {/* Red Carpet */}
          <path d="M60 200 L140 200 L120 100 L80 100 Z" fill="#BE123C" data-id="element-3876" data-mp="2wwzwuu5t3srm" />
          <path d="M70 200 L130 200 L115 100 L85 100 Z" fill="#E11D48" data-id="element-3877" data-mp="2wyuk4f4jvwyv" />
        </svg>

        {/* Throne behind Djay */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3878" data-mp="36v5x77bysqud">
          <path d="M60 140 L60 60 Q100 30 140 60 L140 140 Z" fill="#F59E0B" data-id="element-3879" data-mp="3brnytyc0092h" />
          <path d="M65 140 L65 65 Q100 40 135 65 L135 140 Z" fill="#FCD34D" data-id="element-3880" data-mp="3glirhr9kzydp" />
          <circle cx="100" cy="50" r="10" fill="#EF4444" data-id="element-3881" data-mp="3kl9fxobmy2f2" />
          <rect x="50" y="100" width="15" height="40" rx="4" fill="#D97706" data-id="element-3882" data-mp="3plf6t2a2zkw3" />
          <rect x="135" y="100" width="15" height="40" rx="4" fill="#D97706" data-id="element-3883" data-mp="3pjaym855fzq0" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-end justify-center pb-[15%]" data-id="element-3884" data-mp="1ui8taap28g9i">
          <div className="w-[65%] h-[65%] flex items-center justify-center" data-id="element-3885" data-mp="1ufwcw1yyadyk">
            <DjaySpecimen look={{
            variant,
            accessory: 'scepter'
          }} size="hero" emotion={isUnlocked ? 'proud' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-3886" data-mp="1pkz6z3wywkpw" />
          </div>
        </div>

        {/* Foreground: Sparkles */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3887" data-mp="296vl3bvvj0hm">
            <path d="M40 80 L42 90 L50 92 L42 94 L40 104 L38 94 L30 92 L38 90 Z" fill="#FDE047" data-id="element-3888" data-mp="2i60gi9c52dpk" />
            <path d="M160 60 L161 65 L165 66 L161 67 L160 72 L159 67 L155 66 L159 65 Z" fill="#FDE047" data-id="element-3889" data-mp="nulpzqbb0a8r" />
            <path d="M150 140 L152 148 L160 150 L152 152 L150 160 L148 152 L140 150 L148 148 Z" fill="#FDE047" data-id="element-3890" data-mp="2zhxjypk8q29n" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}